import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from 'src/app/config/config';
import { Environment } from 'src/app/config/environment';
import { METHOD_TYPE } from 'src/app/constants/service.constants';
import { ServiceRouter } from '../core/http-service-router.service';
import { HAFamilyHistoryOption } from 'src/app/modules/shared/types';

/**
 * contains api related to lookup
 */
@Injectable()
export class LookupService {
	/**
	 * constructor
	 * @param environment
	 * @param serviceRouter
	 * @param config
	 */
	constructor(
		private environment: Environment,
		private serviceRouter: ServiceRouter,
		private config: Config
	) {}

	/**
	 * gets ethnic background lookup values
	 */
	getEthnicBackgroundLookupValues(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.ethnicBackgroundLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 * gets marital status lookup values
	 */
	getMaritalStatusLookupValues(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.maritalStatusLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 * gets education level lookup values
	 */
	getEducationLevelLookupValues(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.educationLevelLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 * gets medical conditions lookup values
	 */
	getMedicalConditionLookupValues(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.medicalConditionsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getSatisfiedWithSleepLookupValues(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.satisfiedWithSleepLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getDifficultyWithSleepLookupValues(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.difficultyWithSleepLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getHowYouThinkProblemOptionsLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.howYouThinkProblemOptionsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getConsiderMyselfRatingLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.considerMyselfRatingLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getCharacterizationDescribeRatingOptionsLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.characterizationDescribeRatingOptionsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getThinkReactionOptionsLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.thinkReactionOptions,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getHealthGoalsLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.healthGoalsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
	/**
	 * gets mens health concerns lookup values
	 */
	getMensHealthConcerns(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.menHealthConcernsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	/**
	 * gets womens health concerns lookup values
	 */
	getWomensHealthConcerns(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.womenHealthConcernsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	alcoholDrinksPerDayLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.alcoholDrinksPerDayLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	alcoholDrinksMoreThanSixLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.alcoholDrinksMoreThanSixLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
	alcoholDrinksFrequencyookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.alcoholFrequencyLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	safetyLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.safetyOptions,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	relativeOptionsLookup(): Observable<{ data: HAFamilyHistoryOption[] }> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.relativeOptions,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	diagnosisOptionsLookup(): Observable<{ data: HAFamilyHistoryOption[] }> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.diagnosisOptions,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	painDiscomfortOptions(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.painDiscomfortOptions,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getWorkingHoursOptions(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.workingHoursLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getNightsAwayFromHomeLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.nightsAwayFromHomeLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
	getGenderIdentityLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.genderIdentityLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getPreferredTitleLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.preferredTitleLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}

	getPreferredPronounsLookup(): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().HA_BASE_URL,
			this.config.url.newHealthAssessmentApi.preferredPronounsLookup,
			METHOD_TYPE.SECURED_GET,
			'',
			this.environment.getEnvironment().HA_BASE_DOMAIN
		);
	}
		
    getHoursMissedFromWorkLookup(): Observable<any> {
        return this.serviceRouter
            .makeRequest(
                this.environment.getEnvironment().HA_BASE_URL,
                this.config.url.newHealthAssessmentApi.hoursMissedFromWorkLookup,
                METHOD_TYPE.SECURED_GET,
                '',
                this.environment.getEnvironment().HA_BASE_DOMAIN
            );
    }

    getHealthProblemAbilityAffectLookup(): Observable<any> {
        return this.serviceRouter
            .makeRequest(
                this.environment.getEnvironment().HA_BASE_URL,
                this.config.url.newHealthAssessmentApi.healthProblemAbilityAffectLookup,
                METHOD_TYPE.SECURED_GET,
                '',
                this.environment.getEnvironment().HA_BASE_DOMAIN
            );
    }
}
